// @ngInject
function informationDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'informationDialogController as vm',
            templateUrl: 'services/dialogs/informationDialog/informationDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function informationDialogController($uibModalInstance, message, $sce) {
    var vm = this;

    vm.message = $sce.trustAsHtml(message);

    vm.closeModal = closeModal;

    function closeModal(isCompleted) {
        $uibModalInstance.close(isCompleted);
    }
}

angular
    .module('services.dialogs.informationDialog', [])
    .service('informationDialogService', informationDialogService)
    .controller('informationDialogController', informationDialogController);
